/** Whether the modal is adding a new loan or editing an existing one. */
export enum StandardLoanModalMode {
    New = 'new',
    Edit = 'edit',
}

/** The modal title for each mode. */
export const standardLoanModalTitles: Record<StandardLoanModalMode, string> = {
    [StandardLoanModalMode.New]: 'Add Loan',
    [StandardLoanModalMode.Edit]: 'Update Loan',
};
